<div class="container-fluid d-flex flex-column container-xxl overflow-hidden gx-sm-9 gx-lg-10 gx-xxl-0 py-12">
    <div class="button-box pb-4 align-self-end me-5">
        <a class="btn btn-outline btn-primary pe-8 ps-4 py-4 d-flex justify-content-between align-items-center" [routerLink]="backLink"
            ><img src="/assets/images/icons/arrow-right.svg" class="arrow-icon me-4" alt="" />
            <span>{{ 'BUTTONS.back' | translate }}</span>
        </a>
    </div>
    <div class="d-lg-flex align-items-center border border-gray-100">
        <div class="product-single-image-col">
            <div class="product-single-image-wrapper">
                <div>
                    <div class="d-flex flex-column h-100">
                        <div class="position-relative img flex-grow-1">
                            <img class="product-single-image" [src]="img" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="product-single-data-col">
            <div class="product-single-data-wrapper">
                @if (product.name !== product.patternName) {
                    <h1 class="fs-2 fs-lg-45 fw-700 text-primary mb-5 mb-sm-7">
                        {{ product.name }}
                    </h1>
                }
                <div class="mt-4 mt-lg-7">
                    <h2 class="fs-19 fs-lg-29 fw-700 mb-1 mb-lg-2">{{ product.patternName }}</h2>
                    <div>{{ 'PRODUCT.pattern_num' | translate }}</div>
                    <div class="border-bottom border-gray-100 mt-4 mt-lg-7"></div>
                </div>
                <div class="mt-4 mt-lg-7">
                    <h2 class="fs-19 fs-lg-29 fw-700 mb-1 mb-lg-2">{{ product.parameters.width }}mm</h2>
                    <div>{{ 'PRODUCT.width' | translate }}</div>
                    <div class="border-bottom border-gray-100 mt-4 mt-lg-7"></div>
                </div>
                @if (showWidthWithStone) {
                    <div class="mt-4 mt-lg-7">
                        <h2 class="fs-19 fs-lg-29 fw-700 mb-1 mb-lg-2">{{ product.parameters.width_z_kam }}mm</h2>
                        <div>{{ 'PRODUCT.width_with_stone' | translate }}</div>
                        <div class="border-bottom border-gray-100 mt-4 mt-lg-7"></div>
                    </div>
                }

                @if (height) {
                    <div class="mt-4 mt-lg-7">
                        <h2 class="fs-19 fs-lg-29 fw-700 mb-1 mb-lg-2">{{ product.parameters.height }}mm</h2>
                        <div>{{ 'PRODUCT.height' | translate }}</div>
                        <div class="border-bottom border-gray-100 mt-4 mt-lg-7"></div>
                    </div>
                }

                @if (showHeightWithStone) {
                    <div class="mt-4 mt-lg-7">
                        <h2 class="fs-19 fs-lg-29 fw-700 mb-1 mb-lg-2">{{ product.parameters.height_z_kam }}mm</h2>
                        <div>{{ 'PRODUCT.height_with_stone' | translate }}</div>
                        <div class="border-bottom border-gray-100 mt-4 mt-lg-7"></div>
                    </div>
                }

                @if (product.parameters.stone_label) {
                    <div class="mt-4 mt-lg-7">
                        <h2 class="fs-19 fs-lg-29 fw-700 mb-1 mb-lg-2">{{ product.parameters.stone_label }}</h2>
                        <div>{{ 'PRODUCT.stone_label' | translate }}</div>
                        <div class="border-bottom border-gray-100 mt-4 mt-lg-7"></div>
                    </div>
                }
                @if (product.parameters.default_ct_count) {
                    <div class="mt-4 mt-lg-7">
                        <h2 class="fs-19 fs-lg-29 fw-700 mb-1 mb-lg-2">{{ product.parameters.default_ct_count }}ct</h2>
                        <div>{{ 'PRODUCT.default_ct_count' | translate }}</div>
                        <div class="border-bottom border-gray-100 mt-4 mt-lg-7"></div>
                    </div>
                }
                @if (product.parameters.weight) {
                    <div class="mt-4 mt-lg-7">
                        <h2 class="fs-19 fs-lg-29 fw-700 mb-1 mb-lg-2">{{ product.parameters.weight }}</h2>
                        <div>{{ 'PRODUCT.default_ct_count' | translate }}</div>
                        <div class="border-bottom border-gray-100 mt-4 mt-lg-7"></div>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
